import { ProductCategoryKind } from '@aimpact-korea/arrange-front-types';
import {
  QueryFunctionContext,
  QueryKey,
  useQuery,
  UseQueryOptions
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useErrorHandler } from 'react-error-boundary';
import { arrangeAppApi } from '../../../utils/axios';

export namespace FetchLastCategoryIdToWhole {
  export type ResponseType = {
    productCategoryLevels: {
      id: number;
      parentId: number | null;
      level: number;
      isEtc: boolean;
      name: string;
      kind: ProductCategoryKind | null;
      order: number;
    }[];
    name: string;
  };

  export type RequestType = {
    lastCategoryId: number;
  };

  export const KEY_STRING = 'fetch-last-category-id-to-whole' as const;

  type TQueryKey = [typeof KEY_STRING, RequestType];
  type TQueryKey2 = TQueryKey & QueryKey;

  export async function fetchData({
    queryKey
  }: QueryFunctionContext<TQueryKey2>) {
    return await arrangeAppApi.get<ResponseType>(
      `/product-category/last-category-id-to-whole/${queryKey[1].lastCategoryId}`
    );
  }

  export const useFetchQuery = (
    { lastCategoryId }: RequestType,
    {
      ...props
    }: UseQueryOptions<
      AxiosResponse<ResponseType>,
      AxiosError,
      AxiosResponse<ResponseType>,
      TQueryKey
    > = {}
  ) => {
    const errorHandler = useErrorHandler();

    const query = useQuery(
      [
        KEY_STRING,
        {
          lastCategoryId
        }
      ],
      fetchData,
      {
        refetchOnWindowFocus: false,
        staleTime: 300000,
        onError: errorHandler,
        enabled: !!lastCategoryId,
        ...props
      }
    );

    return query;
  };
}
